import React, { useState, useEffect } from "react";
import { Switch, Route, Redirect, withRouter, useHistory } from "react-router-dom";
import Home from "./Components/HomePage";
import Auth from "./Components/Auth";
import Dashboard from "./Components/Dashboard";
import Assessments from "./Components/Assessments";
import Patients from "./Components/Patients";
import PatientDetail from "./Components/PatientDetail";
import AdminLogin from "./Components/Adminlogin";
import AdminDashboard from "./Components/Admindashboard";
import DoctorsList from "./Components/Doctorslist";
import Example from "./Components/CrfForm";
import Terms from "./Components/Terms"
import AdminSettings from "./Components/AdminSettings";
import { ConnectedLogin } from "./Components/Login";
import SuperAdmin from "./Components/SuperAdmin";
import ClientAdmin from "./Components/ClientAdmin";
import Navbar from "./Components/Navbar";
import Topbar from "./Components/Topbar";
import PatientDetailsNew from "./Components/PatientDetailsNew";
import AdminNavbar from "./Components/AdminNavbar";
import NoNetwork from "./Assets/images/no-network-image.png";
import Swaasa from "./Assets/images/Swaasa.png";
import "./App.css";
import { Login } from "./Components/Login";
import MedicalRecords from "./Components/MedicalRecords";
import Configurations from "./Components/Configurations";
import { useFetchOnlineStatus } from "./utils/useFetchOnlineStatus";
import DoctorDetails from "./Components/DoctorDetails";
import ValidationHome from "./Components/ValidationHome";
import ForgotPassword from "./Components/ForgotPassword";
import ResetPassword from "./Components/ResetPassword";
import { Payments } from "./Components/Payments";
import { DRLOrgs } from "./Components/DRLOrgs";
import { Export } from "./Components/Export";
import { DataProvider } from "./Components/DataProvider";
import DRLDoctors from "./Components/DRLDoctors";

const App = (props) => {
  const [collapsed, setCollapsed] = useState(false);
  const onlineStatus = useFetchOnlineStatus();
  const history = useHistory();
  const urlParams = new URLSearchParams(window.location.search);

  useEffect(() => {
    const token = urlParams.get("token");
    const pageType = urlParams.get("page");
    localStorage.setItem("page", pageType);

    if (localStorage.page === "accounts") {
      localStorage.setItem("patientPayment", "true");
      localStorage.setItem("clinics", "true");
      localStorage.setItem("accessToken", token);
      history.push("/payments");
    }
  }, [history]);

  const handleToggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  const handleToggleCollapseAdmin = () => {
    setCollapsed(!collapsed);
  };

  const navbarComponent = localStorage.accessToken ? (
    localStorage.user === "admin" ? (
      <AdminNavbar onToggleCollapseAdmin={handleToggleCollapseAdmin} />
    ) : (
      <Navbar onToggleCollapse={handleToggleCollapse} />
    )
  ) : null;

  const navWidthClass = !collapsed ? "navWidth" : "navWidth2";

  // Special case for /terms
  if (window.location.pathname === "/terms") {
    return (
      <div>
        <Switch>
          <Route path="/terms" component={Terms} />
        </Switch>
      </div>
    );
  }

  let routes = (
    <Switch>
      <Route path="/" component={ConnectedLogin} exact />
      <Route path="/admin" component={AdminLogin} />
      <Route path="/forgotPassword" component={ForgotPassword} exact />
      <Route path="/password_reset" component={ResetPassword} exact />
      <Route path="/*" component={() => <Redirect to="/" />} />
    </Switch>
  );

  if (localStorage.accessToken && !window.location.pathname.includes("/password_reset")) {
    routes = (
      <div className="appContainer">
        <div className={navWidthClass}>{navbarComponent}</div>
        <div className="containerWidth">
          <Switch>
            <Route path="/" exact>
              {localStorage.page === "accounts" ? (
                <Redirect to="/payments" />
              ) : localStorage.user === "admin" ? (
                <Redirect to="/adminDashboard" />
              ) : localStorage.validation === "true" &&
                localStorage.longitudinal_study !== "true" ? (
                <Redirect to="/validationHome" />
              ) : (
                <Redirect to="/home" />
              )}
            </Route>
            <Route path="/validationHome" component={ValidationHome} />
            <Route path="/home" component={Dashboard} />
            <Route path="/assessments" component={Assessments} />
            <Route path="/patients" component={Patients} />
            <Route path="/adminsettings" component={Configurations} />
            <Route path="/patient/:doctorId/:patientId/" component={PatientDetail} />
            <Route path="/admindashboard" component={AdminDashboard} />
            <Route path="/doctorslist" component={DoctorsList} />
            <Route path="/export" component={Export} />
            <Route path="/superadmin" component={SuperAdmin} />
            <Route path="/payments" component={Payments} />
            <Route path="/clientadmin/:clientId/:clientName" component={ClientAdmin} />
            <Route path="/crf/:doctorId/:patientId" component={Example} />
            <Route path="/doctorDetails/:loginId" component={DoctorDetails} />

            <DataProvider>
              {localStorage.patientPayment === "true" && (
                <Route path="/drl-orgs" component={DRLOrgs} />
              )}
              {localStorage.patientPayment === "true" && (
                <Route path="/drl-doctors" component={DRLDoctors} />
              )}
            </DataProvider>

            <Route path="*">
              {localStorage.page === "accounts" ? (
                <Redirect to="/payments" />
              ) : localStorage.user === "admin" ? (
                <Redirect to="/adminDashboard" />
              ) : localStorage.validation === "true" &&
                localStorage.longitudinal_study !== "true" ? (
                <Redirect to="/validationHome" />
              ) : (
                <Redirect to="/home" />
              )}
            </Route>
          </Switch>
        </div>
      </div>
    );
  }

  if (onlineStatus === false) {
    return (
      <div className="network-container">
        <div className="swaasa-container">
          <img className="swaasa-image" src={Swaasa} alt="swaasa" />
        </div>
        <div className="no-network-container">
          <img src={NoNetwork} className="no-network-image" alt="no-internet" />
          <h2 className="network-heading">Can't find the network</h2>
          <h5 className="network-para">Check your connection & try again later</h5>
        </div>
      </div>
    );
  }

  return (
    <div className="app-container">
      <div>{routes}</div>
    </div>
  );
};


export default withRouter(App);
